import { mapGetters, mapActions } from "vuex";
import { types as pickupSearch } from "@/store/pickup";
import store from "@/store";
import { getZtOrder, latestExpressSearchApi } from "@/libs/api";
import orderItem from "@/components/pickup/orderItem.vue";
const getters = mapGetters({
  getSearchHistoryList: pickupSearch.HISTORY_KEYWORDS_LIST,
});
const actions = mapActions({
  setSearchHistoryList: pickupSearch.HISTORY_KEYWORDS_LIST,
});
export default {
  name: "pickupSearch",
  components: { orderItem },
  data() {
    return {
      // 搜索接口参数
      query: {
        pageSize: 10,
        startIndex: 1,
        siteId: "",
        keywords: "",
        orderStatus: 0,
      },
      loading: false,
      finished: false,
      isLoad: false,
      finishedText: "",
      searchStatus: "0", // 0-未搜索 1-搜索有数据 2-搜索无数据
      isShowHistory: true, // 是否显示历史搜索
      noDataVal: "",
      // 订单列表
      orderListArr: [],
      logisticsList: {},
    };
  },
  mounted() {
    // document.querySelector("body").classList.add("bg-fff");
    this.query.siteId = this.$route.query.siteId;
    this.query.keywords = this.$route.query.keywords;
    if (this.query.keywords) {
      this.setSearchHistoryList(this.query.keywords);
      this.noDataVal = this.query.keywords;
      this.query.keywords = this.query.keywords;
      this.getOrderList();
    }
    this.$once("hook:beforeDestroy", () => {
      document.querySelector("body").classList.remove("bg-fff");
    });
  },
  computed: {
    ...getters,
  },
  methods: {
    ...actions,
    // 获取自提订单列表
    getOrderList() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      getZtOrder(this.query, "jsonCallback").then((res) => {
        this.loading = false;
        this.finished = false;
        let pkgInfo = [];
        if (res.returnCode === "0000") {
          if (!res.data) {
            this.isEmpty = true;
            this.finished = true;
            this.finishedText = "";
            this.searchStatus = 2;
            this.isShowHistory = true;
          } else {
            this.orderListArr = this.orderListArr.concat(res.data);
            this.searchStatus = 1;
            res.data.forEach((item) => {
              if (item.orderStatus != 3 && item.orderStatus != 4) {
                pkgInfo.push({
                  packageNo: item.delevery[0].packageId,
                  escOrderId: item.escOrderId,
                });
              }
            });
            console.log("pkgInfo====", pkgInfo);
            let pkgInfoJson = JSON.stringify(pkgInfo);
            console.log("pkgInfoJson", pkgInfoJson);
            this.getLogisticsInfo(pkgInfoJson);
            let totalPages = Math.ceil(res.total / this.query.pageSize);
            // if (this.query.pageSize * this.query.startIndex >= res.total) {
            if (this.query.startIndex == totalPages) {
              this.finished = true;
              this.finishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.query.startIndex++;
              this.finished = false;
            }
            this.isShowHistory = false;
          }
        } else {
          this.finished = true;
        }
        setTimeout(() => {
          this.$toast.clear();
        }, 1000);
      });
    },
    getLogisticsInfo(pkgInfoJson) {
      latestExpressSearchApi({ pkgInfoJson: pkgInfoJson, clientCallType: "H5" }).then((res) => {
        if (res.returnCode == "0000") {
          this.logisticsList = { ...this.logisticsList, ...res.data };
        }
        console.log("logisticsList===", this.logisticsList);
      });
    },
    // 搜索事件
    onSearch(val) {
      if (val === "") {
        return false;
      } else {
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: "加载中...",
        });
        // 存入历史记录
        this.setSearchHistoryList(val);
        this.noDataVal = val;
        this.query.keywords = val;
        this.getOrderList();
      }
    },
    // 点击搜索
    clickSearch(val) {
      this.query.keywords = val;
      this.onSearch(val);
    },
    // 删除历史记录
    clearHistory() {
      store.commit(pickupSearch.HISTORY_KEYWORDS_LIST, []);
    },
  },
};
